import React from 'react';
import Component from '@vfuk/core-image-carousel';
const ImageCarousel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default ImageCarousel;
